import React from 'react';
import { useIntl } from 'react-intl';
import { TeamMemberStatistics } from '../../../../models/TeamMemberStatistics';

type StatisticsProps = {
  statistics: TeamMemberStatistics;
};

const Statistics: React.FC<StatisticsProps> = ({ statistics }: StatisticsProps) => {
  const intl = useIntl();
  if (statistics.frequency.invited == 0) {
    return null;
  }
  return (
    <div className='padding-bottom-m three-fourth' data-testid='statistics'>
      {statistics.frequency.invited && (
        <p className='font-bold padding-bottom-m' data-testid='statistics.invited'>
          {intl.formatMessage({ id: 'teammanagement.statistics.invited.description' }, { total: statistics.frequency.invited })}
        </p>
      )}
    </div>
  );
};

export default Statistics;
